export * from './phrases'
export * from './context'


export const targetAdjecentX = [295, 365, 435]

export const targetAdjecentY = [155, 225, 295]